import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptVirginia = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Virginia Non-Profit Filing Requirements & Deadlines."
          description="Learn Virginia’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state."
          keywords=" "
          canonical="nonprofit-taxes/virginia-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-va-landing-img.webp" />
                <source srcSet="/assets/images/state-va-landing-img.png" />
                <img
                  src="/assets/images/state-va-landing-img.png"
                  alt="Virginia State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Virginia State</span>
                </span>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                The key state filings for Virginia nonprofits include the Annual
                Report with the State Corporation Commission, the Charitable
                Solicitation Renewal with the Office of Charitable and
                Regulatory Programs, and the Sales and Use Tax Exemption Renewal
                with the Department of Taxation.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=virginia`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-va-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-va-landing-img-sm.png" />
                <img
                  src="/assets/images/state-va-landing-img-sm.png"
                  alt="Virginia State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Virginia are required to complete several forms as
            part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Filing Requirement
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Form/Report
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Description
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <Link
                            href="https://www.scc.virginia.gov/media/sccvirginiagov-home/business-home/start-a-new-business/business-types/scc819.pdf"
                            sx={{ color: '#0202ff' }}
                            target="_blank"
                          >
                            {' '}
                            Form SCC819{' '}
                          </Link>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Official form to create a Virginia nonprofit nonstock
                          corporation.
                        </TableCell>

                        <TableCell
                          rowSpan={4}
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              Form 1023 (Application for Recognition of
                              Exemption Under Section 501(c)(3) of the Internal
                              Revenue Code): For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 16 }}>
                              Form 1024 (Application for Recognition of
                              Exemption Under Section 501(a) or Section 521 of
                              the Internal Revenue Code): For other types of
                              nonprofits.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 990 (Return of Organization Exempt From
                                Income Tax)
                              </Link>
                              : Annual information return for <br /> tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              Charitable Registration Application (Initial
                              Registration){' '}
                            </li>
                            <li>Charitable Organization Annual Renewal </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <Link
                            href="https://www.vdacs.virginia.gov/pdf/oca102registrationstatement.pdf"
                            sx={{ color: '#0202ff' }}
                            target="_blank"
                          >
                            {' '}
                            Form 102{' '}
                          </Link>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Initial and annual registration for charitable
                          solicitations in Virginia
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Sales and Use Tax Exemption Application for Nonprofit
                          Organizations
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <Link
                            href="https://www.tax.virginia.gov/sites/default/files/taxforms/exemption-certificates/any/np-1-application-any.pdf"
                            sx={{ color: '#0202ff' }}
                            target="_blank"
                          >
                            {' '}
                            Form NP-1
                          </Link>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Application for exemption from Virginia sales and use
                          tax
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Virginia Department of Taxation Business
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <Link
                            href="https://www.tax.virginia.gov/sites/default/files/taxforms/business-registration/any/r-1-any.pdf"
                            sx={{ color: '#0202ff' }}
                            target="_blank"
                          >
                            {' '}
                            Form R-1
                          </Link>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Registration for state tax purposes, such as income
                          tax withholding, sales tax, etc
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Virginia’s active civic community and supportive environment
                make it an ideal place to start a nonprofit{' '}
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                To operate legally, you must meet state filing requirements:
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <span style={{ fontWeight: 600 }}>Choose Your Structure</span>{' '}
                  – Most nonprofits are formed as nonprofit corporations.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Name Your Organization
                  </span>{' '}
                  – Select a unique name following state rules (check
                  availability via the Virginia
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    State Corporation Commission (SCC) Business Entity
                  </span>{' '}
                  Search Portal)
                </li>

                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Appoint a Registered Agent
                  </span>{' '}
                  – A Virginia resident or an authorized entity maintaining a
                  physical address in Virginia to receive all legal and tax
                  correspondence on behalf of the organization
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    File Formation Documents{' '}
                  </span>{' '}
                  – File the Articles of Incorporation with the Virginia State
                  Corporation Commission (SCC), accompanied by the statutory
                  filing fee of $75
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Adopt Bylaws & Hold Meetings
                  </span>{' '}
                  – Establish bylaws, elect officers, and begin operations with
                  your board.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-va-img.webp" />
                <source srcSet="/assets/images/who-file-va-img.png" />
                <img
                  src="/assets/images/who-file-va-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 3, borderRadius: 5, maxWidth: 900 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  {/* <Typography
                    component={'div'}
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    To gain tax-exempt status, a nonprofit must meet specific
                    requirements set by the IRS.
                  </Typography> */}
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li': {
                        // float: 'left',
                        fontSize: 16,
                        display: 'flex',
                      },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        To gain tax-exempt status, a nonprofit must meet
                        specific requirements set by the IRS.
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        {' '}
                        Obtaining an IRS Determination Letter for 501(c) status
                        (most commonly 501(c)(3)) is the critical first step, as
                        it dictates eligibility for Virginia corporate tax
                        benefits.
                      </Box>
                    </li>

                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                      />
                      <Box>
                        Not all nonprofits automatically qualify for the
                        Virginia sales tax exemption. Eligible organizations
                        must apply to the Virginia Department of Taxation for a
                        Certificate of Exemption.
                      </Box>
                    </li>

                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                      />
                      <Box>
                        All 501(c) nonprofits must annually file IRS Form 990,
                        990-EZ, or 990-N depending on gross receipts and type of
                        organization.
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                      />
                      <Box>
                        Applications for Virginia state sales tax exemption must
                        include proof of IRS 501(c)(3) status and may also
                        require submission of organizational documents, such as
                        Articles of Incorporation and Bylaws.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'left' }}>
                Below are the key deadlines for non-profit filings in Virginia:
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 330,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due upon establishment of the nonprofit $75 filing
                          fee.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            // fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Nonstock corporations (nonprofits) are required to
                          file an{' '}
                          <span style={{ fontWeight: 600 }}>
                            Annual Report for corporations
                          </span>{' '}
                          with the SCC.
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due each year by the{' '}
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            last day of the 12th month after incorporation
                          </span>
                          .
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Business Regulation Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 330,
                          }}
                        >
                          Charitable Organization Initial Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Before soliciting contributions. ($30–$325)
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Annual Charitable Solicitation Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Annually, by the 15th day of the 5th month after the
                          close of the fiscal year Varies, $100 late fee if
                          missed
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=virginia`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: { md: 17, sm: 16, xs: 15 }, textAlign: 'center' }}
          >
            To operate legally as a non-profit in Virginia, organizations must
            file the Articles of Incorporation{' '}
            <Hidden smDown>
              <br />
            </Hidden>
            with the Secretary of State and pay the $75 filing fee.{' '}
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        File Articles of Incorporation
                      </span>{' '}
                      with{' '}
                      <span style={{ fontWeight: 600 }}>(Form SCC819)</span>{' '}
                      with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Virginia State Corporation Commission (SCC)
                      </span>
                      . Filing fee: <span style={{ fontWeight: 600 }}>$75</span>
                      .
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        Research IRS Requirements
                      </span>
                      <br />
                      Ensure Articles and Bylaws include IRS-mandated 501(c)(3)
                      language if pursuing exemption.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Obtain EIN</span>
                      <br />
                      Apply online with the IRS.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Select a Registered Agent
                      </span>
                      <br />
                      Must maintain a{' '}
                      <span style={{ fontWeight: 600 }}>
                        physical Virginia
                      </span>{' '}
                      address to receive legal and tax correspondence on behalf
                      of the organization
                    </li>

                    <li style={{ marginTop: 10 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Recruit a Board of Directors
                      </span>
                      <br />
                      Virginia requires at least three directors.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Secretary of State Annual Report{' '}
                      </span>
                      <br />
                      File annually by the last day of the month of
                      incorporation. Fee: $25
                    </li>

                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Charitable Organization Registration
                      </span>
                      <br />
                      Required before soliciting contributions.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Charitable Organization Annual Renewal
                      </span>
                      <br />
                      Renew annually with VDACS by the 15th day of the 5th month
                      after fiscal year end, aligning with IRS Form 990
                      deadlines.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        IRS Form 990 Series
                      </span>
                      <br />
                      File annually.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Maintain Records</span>
                      <br />
                      Corporate records, board meeting minutes, and financial
                      statements must be maintained as required by Virginia
                      nonprofit law.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Efficient Compliance and Filing Services
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone provides nonprofits with trusted and accurate IRS filing
          support.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=virginia`}
          >
            E-File Now
          </Button>
        </Box> */}
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How do I register a nonprofit in Virginia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      To form a nonprofit corporation, file{' '}
                      <span style={{ fontWeight: 600 }}>
                        Articles of Incorporation (Form SCC819)
                      </span>{' '}
                      with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Virginia State Corporation Commission (SCC)
                      </span>
                      . Include the nonprofit’s name, purpose, registered agent,
                      and incorporators. The filing fee is $75.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do I need to register as a charity before fundraising?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Yes. Any nonprofit soliciting contributions in Virginia
                      must{' '}
                      <span style={{ fontWeight: 600 }}>
                        register with the Virginia Department of Agriculture and
                        Consumer Services (VDACS)
                      </span>{' '}
                      using <span style={{ fontWeight: 600 }}>Form 102</span>.
                      Submit your IRS Determination Letter, Articles of
                      Incorporation, Bylaws, and financial statements.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. When are annual filings due for a Virginia nonprofit?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        SCC Annual Report:
                      </span>{' '}
                      Last day of the month of incorporation. ($25 fee) <br />{' '}
                      <span style={{ fontWeight: 600 }}>
                        VDACS Charitable Organization Renewal:
                      </span>{' '}
                      15th day of the 5th month after fiscal year end (aligns
                      with IRS Form 990).
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 0 }}>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        IRS Form 990 Series:
                      </span>{' '}
                      15th day of the 5th month after fiscal year end (May 15
                      for calendar-year organizations).
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What fees are associated with charitable registration in
                  Virginia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Initial registration:
                      </span>{' '}
                      $100 (for organizations with prior financial history)
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Annual renewal fees:
                      </span>{' '}
                      Vary based on gross contributions ($30–$325)
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <span style={{ fontWeight: 600 }}> Late fees:</span> $100
                      for late renewal submissions
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What records must Virginia nonprofits maintain?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Nonprofits are required to maintain{' '}
                      <span style={{ fontWeight: 600 }}>
                        corporate records, board meeting minutes, bylaws,
                        financial statements
                      </span>
                      , and copies of IRS filings (Form 990 series). These
                      documents may be requested by regulators or auditors to
                      ensure compliance with state and federal law
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        {' '}
                        <Link
                          href="https://www.scc.virginia.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          SCC-Virginia State Corporation Commission (SCC)
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/charities-non-profits"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS – Charities and Non-Profits
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptVirginia;
